import React from 'react'
import { Outlet } from 'react-router-dom'

const Service = () => {
    return (
        <><Outlet /></>
    )
}

export default Service